import { render, staticRenderFns } from "./six.vue?vue&type=template&id=94566fa6&scoped=true&"
var script = {}
import style0 from "./six.vue?vue&type=style&index=0&id=94566fa6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94566fa6",
  null
  
)

export default component.exports